import api from './AxiosInstance';

export class ExerciceService {
    
    
         getAllExercices = async () => {
            try {
              const response = await api.get(`/Compta/Exercices`);
              return response.data;
            } catch (error) {
              console.error('Erreur lors de la récupération des données :', error);
            
            }
          };
  
        
    
}